import { ArrowBackRounded } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { Translate } from 'react-jhipster';
import VirtualFenceMap from './VirtualFenceMap';

export const VirtualFence = props => {
  const isEdit = props.match.params && props.match.params.id;

  return (
    <Box sx={{ backgroundColor: 'primary.main', borderRadius: '8px', padding: '24px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box display="flex" alignItems="center" minWidth={0}>
          <IconButton onClick={() => props.history.goBack()} aria-label="goBack" size="large" sx={{ color: 'text.secondary' }}>
            <ArrowBackRounded />
          </IconButton>
          <Typography
            id="fleetSenseApp.virtualFenceCircle.home.createOrEditLabel"
            data-cy="VirtualFenceCircleCreateUpdateHeading"
            variant="h5"
            sx={{ fontSize: '1.5rem', color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
          >
            {isEdit ? (
              <Translate contentKey="fleetSenseApp.virtualFenceCircle.home.editLabel">Edit VirtualFenceCircle</Translate>
            ) : (
              <Translate contentKey="fleetSenseApp.virtualFenceCircle.home.createLabel">Create a new VirtualFenceCircle</Translate>
            )}
          </Typography>
        </Box>
      </Box>
      <VirtualFenceMap props={props} />
    </Box>
  );
};
